// src/components/Hermes/QuickActions.tsx
import type { QuickAction } from './types';

interface QuickActionsProps {
  actions: QuickAction[];
  onAction: (action: QuickAction) => void;
  loading?: boolean;
}

export default function QuickActions({
  actions,
  onAction,
  loading = false,
}: QuickActionsProps) {
  if (!actions || actions.length === 0) return null;

  return (
    <div className="flex items-center gap-1.5 px-4 py-2 border-b border-white/5 flex-wrap">
      {actions.map((action) => (
        <button
          key={action.id}
          onClick={() => onAction(action)}
          disabled={loading || action.disabled}
          className={`
            px-2.5 py-1 rounded-lg text-xs transition whitespace-nowrap
            ${
              loading || action.disabled
                ? 'opacity-30 cursor-not-allowed bg-white/5 text-gray-500'
                : 'bg-white/5 hover:bg-white/10 text-gray-400 hover:text-white'
            }
          `}
        >
          {action.icon && <span className="mr-1">{action.icon}</span>}
          {action.label}
          {action.runtime && (
            <span className="ml-1 text-[10px] text-gray-500">
              · {action.runtime}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}